import React from 'react';
import './SubtitleItem.css';

type SubtitleItemProps = {
  text: string;
  left: number;
  colorCode: string;
}
/**
 * 字幕本体コンポーネント
 */
function SubtitleItem(props: SubtitleItemProps) {
  // 文字が消えてしまうと高さが算出できなくなるので、仮の文字を設定してopacityで消す
  return (
    <div
      className='SubtitleItem'
      style={{ 
          marginLeft: props.left + '%',
          opacity: (props.text === '' ? 0 : 1),
          color: props.colorCode
      }}
    >
      {(props.text === '' ? '.' : props.text)}
    </div>
  );
}

export default SubtitleItem;